import { render, staticRenderFns } from "./EditarSubunidades.vue?vue&type=template&id=0cf93898&scoped=true&"
import script from "./EditarSubunidades.vue?vue&type=script&lang=js&"
export * from "./EditarSubunidades.vue?vue&type=script&lang=js&"
import style0 from "./EditarSubunidades.vue?vue&type=style&index=0&id=0cf93898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf93898",
  null
  
)

export default component.exports